export type TFinSobData = {
  sob: number | null
  revenue: number | null
}

type TGuardedFinSobData = {
  sob: number
  revenue: number
}

/** Σ(revenue × sob) / Σrevenue. Falls back to the plain mean when every weight is zero,
 *  so a partner with SOB but no booked revenue still reads sensibly. */
export const getWeightedSob = (rows: TFinSobData[]): number | null => {
  const filteredRows = rows.filter(
    (it): it is TGuardedFinSobData => it.sob !== null && it.revenue !== null
  )

  if (filteredRows.length === 0) {
    return null
  }

  const totalRevenue = filteredRows.reduce((sum, { revenue }) => sum + revenue, 0)
  if (totalRevenue === 0) {
    const totalSob = filteredRows.reduce((sum, { sob }) => sum + sob, 0)
    const plainAverage = totalSob / rows.length
    return plainAverage
  }

  const weightedAverage =
    filteredRows.reduce((sum, { sob, revenue }) => sum + sob * revenue, 0) / totalRevenue

  if (isNaN(weightedAverage)) {
    return null
  }

  return weightedAverage
}
